"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RainDimensions = exports.Rain = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _emotionIcon = require("@emotion-icons/emotion-icon");

var Rain = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(_emotionIcon.EmotionIconBase, (0, _extends2.default)({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 8 8"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0C3.29 0 2.23.86 2 2 .9 2 0 2.9 0 4c0 .53.2.99.53 1.34.26-.22.6-.34.97-.34.2 0 .39.05.56.13C2.23 4.49 2.8 4 3.5 4c.69 0 1.27.49 1.44 1.13.17-.07.36-.13.56-.13.63 0 1.15.39 1.38.94.64-.17 1.13-.75 1.13-1.44 0-.65-.42-1.29-1-1.5v-.5A2.5 2.5 0 004.51 0zM3.34 5a.5.5 0 00-.34.5v2a.5.5 0 101 0v-2a.5.5 0 00-.59-.5.5.5 0 00-.06 0zm-2 1a.5.5 0 00-.34.5v1a.5.5 0 101 0v-1a.5.5 0 00-.59-.5.5.5 0 00-.06 0zm4 0a.5.5 0 00-.34.5v1a.5.5 0 101 0v-1a.5.5 0 00-.59-.5.5.5 0 00-.06 0z"
  }));
});
exports.Rain = Rain;
Rain.displayName = 'Rain';
var RainDimensions = {
  height: 8,
  width: 8
};
exports.RainDimensions = RainDimensions;